import { ALT_OPTIONS } from '../../lib/windgram';

/**
 * AltitudeSelect — ceiling altitude selector.
 *
 * Renders `<select>` over ALT_OPTIONS with labels "GND – {m}m".
 *
 * Props:
 *   value    — selected altitude in metres
 *   onChange — called with the new altitude as an integer
 */
const AltitudeSelect = ({ value, onChange, disabled = false }) => {
    // Merge the current value (the per-tab auto altitude, e.g. ti's dynamic
    // 4000/5000m) into the options so it's always selectable, then sort desc.
    const options = Array.from(new Set([...ALT_OPTIONS, value])).sort((a, b) => b - a);
    return (
        <select
            value={value}
            disabled={disabled}
            onChange={(e) => onChange(parseInt(e.target.value, 10))}
            className={`text-xs rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
            {options.map((m) => (
                <option key={m} value={m}>
                    GND – {m}m
                </option>
            ))}
        </select>
    );
};

export default AltitudeSelect;
